import React from "react";

import marioAvatar from "../../../_assets/img/registration/mario_konrad.jpeg";
import ryzonLogo from "../../../_assets/img/registration/ryzon.png";
import trustReviews from "../../../_assets/img/registration/trust-reviews.webp";

/**
 * Right-hand social proof panel: Mario Konrad / Ryzon quote + review badges, plus the
 * "already have an account? Login" prompt (top-right over the panel on desktop; it travels
 * with this section on mobile, where the panel stacks below the flow — order: 2 in the SCSS).
 */
const SocialProofPanel = () => {
    return (
        <aside className="registration-social-proof" data-cy="registration-social-proof">
            <div className="registration-social-proof__login">
                <span>Du hast bereits einen Account?</span>
                <a href={"/login"} data-cy="registration-login-link">
                    Login
                </a>
            </div>

            <img className="registration-social-proof__avatar" src={marioAvatar} alt="Mario Konrad" />

            <blockquote className="registration-social-proof__quote">
                “Bei einer Prüfung vom Jahresabschluss ist das Support Team von pathway zusammen mit unserer
                Steuerberatung die extra Meile gegangen und hat uns den A**** gerettet”
            </blockquote>

            <div className="registration-social-proof__author">
                <img className="registration-social-proof__ryzon" src={ryzonLogo} alt="Ryzon" />
                <div className="registration-social-proof__author-name">
                    <strong>Mario Konrad</strong>
                    <span>Founder</span>
                </div>
            </div>

            {/* Combined Shopify App Store / DATEV / OMR review badges (all 4.9) */}
            <img className="registration-social-proof__badges" src={trustReviews} alt="Shopify App Store, DATEV, OMR Reviews — 4,9" />
        </aside>
    );
};

export default SocialProofPanel;
